import React from 'react';
import { BrandsAPI } from '../../../../constructs/brands/interface';
import { useAPIContext } from '../../context/api';
import { triggerBrowserDownload } from './lib/trigger-browser-download';

export const useDownloadFolder = () => {
  const { callEndpoint } = useAPIContext();

  const downloadFolderBatch = React.useCallback(
    async (folderPath: string, batchIndex: number) => {
      const response = await callEndpoint<BrandsAPI, 'download-folder-zip'>(
        'brands',
        `/folders/download/${encodeURIComponent(folderPath)}?batchIndex=${batchIndex}`,
        'GET'
      );

      const folderLabel = folderPath.split('/').pop() || 'folder';
      const filename =
        response.totalBatches > 1
          ? `${folderLabel}-parte-${response.batchIndex + 1}-de-${response.totalBatches}.zip`
          : `${folderLabel}.zip`;
      triggerBrowserDownload(response.downloadUrl, filename);

      return response;
    },
    [callEndpoint]
  );

  return { downloadFolderBatch };
};
